import { render, staticRenderFns } from "./TestimonialsV2.vue?vue&type=template&id=65e52ce3"
import script from "./TestimonialsV2.vue?vue&type=script&lang=js"
export * from "./TestimonialsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports